import {
  API_FleetConversation_massive,
  API_FleetConversation_post,
  API_REQUEST_HEADERS_BASEURL,
} from "../utils/Constants";

const normalizeList = (values) =>
  Array.from(new Set((Array.isArray(values) ? values : []).map((value) => String(value || "").trim()).filter(Boolean)));

export async function sendFleetMessageToDriver({ fleetId, driverId, message, orderId = null }) {
  const endpoint = API_FleetConversation_post.replace("{fleetId}", fleetId);
  const response = await API_REQUEST_HEADERS_BASEURL.post(endpoint, {
    fleetId,
    role: "FLEET",
    message,
    userId: driverId,
    orderId,
    read: false,
    createdAt: new Date().toISOString(),
  });
  return response.data;
}

export async function sendFleetBroadcastMessage({ fleetId, message, tags = [], driverIds = [] }) {
  const endpoint = API_FleetConversation_massive.replace("{fleetId}", fleetId);
  const normalizedTags = normalizeList(tags);
  const normalizedDriverIds = normalizeList(driverIds);
  const response = await API_REQUEST_HEADERS_BASEURL.post(endpoint, {
    fleetId,
    role: "FLEET",
    message,
    orderId: null,
    read: false,
    createdAt: new Date().toISOString(),
    tags: normalizedTags,
    driverIds: normalizedDriverIds,
  });
  return response.data;
}
